import { render, staticRenderFns } from "./CkFooter.vue?vue&type=template&id=0c6cae7d&scoped=true&"
import script from "./CkFooter.vue?vue&type=script&lang=js&"
export * from "./CkFooter.vue?vue&type=script&lang=js&"
import style0 from "./CkFooter.vue?vue&type=style&index=0&id=0c6cae7d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6cae7d",
  null
  
)

export default component.exports